import { NgRxFileShareLibConfig } from '@usf/ngrx-file-share';
import { environment } from 'src/environments/environment';

export const NG_RX_FILESHARE_LIB_CONFIG: NgRxFileShareLibConfig = {
  apiUrl: environment.fileShareApiUrl,
};
